import { getTableInfo, getTableName, openTableWithScanQR } from "@/dataLayer/service/api";
import { goto } from "@/plugins/router";
import { setTableName } from "@/dataLayer/repository/GlobalSettingManager";
import IKUtils from "innerken-js-utils";
import { Remember } from "@/plugins/firebase";

export async function openOrEnterTable(isTakeaway = false) {
  if (getTableName()) {
    const { usageStatus, id } = await getTableInfo();
    try {
      if (usageStatus === "1") {
        goto("/menu");
      } else {
        const res = await openTableWithScanQR(id, isTakeaway);
        if (res.status === "good") {
          goto("/menu");
        }
      }
    } catch (e) {
      console.log(e);
    }
  } else {
    const res = await openTableWithScanQR(null, isTakeaway);
    if (res.status === "good" && res?.content?.tableName) {
      setTableName(res.content.tableName);
      Remember.orderId = res.content.orderId;
      goto("/menu");
    } else {
      IKUtils.showError("Error on open table, info:" + res.info);
    }
  }


}
